<div class="_anonymous-attendance-statistics-component">

    <div class="_statistic-filters">
        <statistic-filter-component [params]="params" [paramsChanged]="paramsChanged" [filters]="filters"></statistic-filter-component>
	</div>	

    <div class="_statistic-components">
        <div class="_statistic-total">
            <anonymous-attendances-count-statistic-component [params]="params" [paramsChanged]="paramsChanged"></anonymous-attendances-count-statistic-component>
        </div>
    
        <div class="_statistics-container">
            <div class="_statistic-container">
                <anonymous-attendances-on-event-types-statistic-component [params]="params" [paramsChanged]="paramsChanged"></anonymous-attendances-on-event-types-statistic-component>
            </div>
            <div class="_statistic-container">
                <anonymous-attendances-on-agencies-statistic-component [params]="params" [paramsChanged]="paramsChanged"></anonymous-attendances-on-agencies-statistic-component>
            </div>
            <div class="_statistic-container">
                <anonymous-attendances-on-locations-statistic-component [params]="params" [paramsChanged]="paramsChanged"></anonymous-attendances-on-locations-statistic-component>
            </div>
        </div>
    </div>

</div>



